import { getLocale } from "../runtime";

const da_offerwillexpire = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tilbuddet udløber om `
};

const en_offerwillexpire = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Offer expires in `
};

const es_offerwillexpire = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `La oferta termina en `
};

const fi_offerwillexpire = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tarjous päättyy`
};

const nb_offerwillexpire = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tilbudet utløper om `
};

const sv_offerwillexpire = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Erbjudandet tar slut om `
};

const offerwillexpire = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_offerwillexpire(inputs)
	if (locale === "en") return en_offerwillexpire(inputs)
	if (locale === "es") return es_offerwillexpire(inputs)
	if (locale === "fi") return fi_offerwillexpire(inputs)
	if (locale === "nb") return nb_offerwillexpire(inputs)
	if (locale === "sv") return sv_offerwillexpire(inputs)
	return "offerWillExpire";
};

export { offerwillexpire as "offerWillExpire" };